import { put } from 'redux-saga/effects';
import { updateElement } from '../actions';

export function* addQuestionElementOptions(state, optionsToAdd) {
  const questionElementsToUpdate = Object.keys(optionsToAdd);

  if (!questionElementsToUpdate.length) {
    return;
  }

  for (let index = 0; index < questionElementsToUpdate.length; index++) {
    const questionElement = state.elements[questionElementsToUpdate[index]];

    yield put(
      updateElement({
        elementId: questionElementsToUpdate[index],
        question: { ...questionElement.question, options: optionsToAdd[questionElementsToUpdate[index]] },
      }),
    );
  }
}
